// @ts-nocheck
import React from 'react';
import AuthSigninView from './view';
import AuthSigninProvider from './state';
import PtlSignup from '../ptlSignup';
import { ErrorBoundary } from 'ErrorBoundary';
import { initSentry } from 'ErrorBoundary/sentryInit';
import { initGlobalCachePrevention } from '../utils/preventBrowserCache';

interface IAuthSigninProps {
}

try {
    const trackerProperties = window.trackerProperties;
    initSentry(
        trackerProperties?.analyticsId
            ? {
                id: trackerProperties.analyticsId,
                extras: {
                    userId: trackerProperties?.guestId,
                    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    created_at: trackerProperties?.createdAt,
                    path: window.location.href,
                },
              }
            : undefined
    );
} catch (e) {
    console.error(e);
}

const AuthSignin: React.FC<IAuthSigninProps> = () => (
    <ErrorBoundary>
        <AuthSigninProvider>
            <AuthSigninView />
        </AuthSigninProvider>
    </ErrorBoundary>
)

// Initialize global cache prevention
initGlobalCachePrevention();

const container = document.getElementById('auth-signin-container-wrap');

if (container) {
    import('react-dom/client').then(({ createRoot }) => {
        const root = createRoot(container);
        root.render(<AuthSignin />);
    })
}

export default AuthSignin;